/**
 * @file Gera os niveis e dimensiona o jogo.<br>
 * Pré-configura 3 niveis de jogo.
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */
/**
 *
 * @module ControlLevel
 */

/** Gera os niveis e controles do jogo.<br>
 * Pré-configura 3 niveis de jogo. */
export default function ControlLevel() {

    this.quantidadesTeclas = 12
    this.widthTeclas = {
        width : '0%'
    }

    this.setFase =  function(fase){
        this.fase = fase
        switch (fase) {
            case 1:
                this.tips = 3;
            break;
            case 2:
                this.tips = 4;
            break;
            case 3:
                this.tips = 5;
            break;
        
            default:
                break;
        }
    }

    this.setDimensoes =  function(largura, altura){
        this.largura = largura;
        this.altura = altura;
    }

    this.setquantidadesTeclas =  function(palavras){
        this.quantidadesTeclas = palavras;
        let frac = 0 

        frac = 100/(this.quantidadesTeclas / 2)

        this.widthTeclas ={
            width : frac + '%'
        }
    }

    this.getFase = function(){
        return this.fase;
    }

    this.getquantidadesTeclas = function(){
        return this.quantidadesTeclas;
    }

    this.setQuantidadePalavras =  function(palavras){
        this.palavras = palavras;
    }

    this.getQuantidadePalavras = function(){
        return this.palavras;
    }

    this.getLargura = function(){
        return this.largura;        
    }

    this.getAltura = function(){
        return this.altura;        
    }

    this.getNivel = function(){
        return this.nivel;        
    }

    this.curiosidades = function(){
        this.nivel = 'CURIOSIDADES';
        this.modo = 'CURIOSIDADE';
        this.setDimensoes(12,12);
        this.setQuantidadePalavras(10);
        this.setquantidadesTeclas(12);
    }

    this.usodasplantas = function(){
        this.nivel = "USO DAS PLANTAS";
        this.modo = 'USO'
        this.setDimensoes(12,12);
        this.setQuantidadePalavras(10);
        this.setquantidadesTeclas(12);
    }

    this.nomepopular = function(){
        this.nivel = "NOME POLULAR";
        this.modo = 'POPULAR'
        this.setDimensoes(12,12);
        this.setQuantidadePalavras(10);
        this.setquantidadesTeclas(12);
    }
   

}
